/**
 * TODO - preamble
 */
import {
    StudentPersonalInfoViewModel,
    AgePersonalInfoViewModel,
    SeniorPersonalInfoViewModel,
    TeacherPersonalInfoViewModel,
    MemberPersonalInfoViewModel,
    ViewModel,
    DocUploadViewModel,
    ActiveMilitaryPersonalInfoViewModel,
    InactiveMilitaryPersonalInfoViewModel,
    FirstResponderPersonalInfoViewModel,
    MedicalProfessionalPersonalInfoViewModel,
    EmploymentPersonalInfoViewModel,
    SSOViewModel,
    VerificationStep,
    SMSLoopViewModel,
} from '../types/types';

import { VerificationStepsEnum } from '../types/runtimeTypes';

import {
    stuPInfoReqEmpty,
    seniorPInfoReqEmpty,
    agePInfoReqEmpty,
    teaPInfoReqEmpty,
    memberInfoReqEmpty,
    activeMilitaryPInfoReqEmpty,
    inactiveMilitaryPInfoReqEmpty,
    firstResponderPInfoReqEmpty,
    medicalProfessionalPInfoReqEmpty,
    docUploadEmpty,
    ssoEmpty,
    employmentPInfoReqEmpty,
    smsLoopEmpty,
} from '../../lib/types/empties';

import { assertValidVerificationStepName } from '../types/assertions';
import { deepClone } from '../utils/objects';
import { logger } from '../utils/logger/logger';

/**
 * Return an empty request object as a starting-point for our run-time model
 */
export const getEmptyViewModel = (currentStep: VerificationStep): ViewModel => {
    assertValidVerificationStepName(currentStep);
    switch (currentStep) {
        case VerificationStepsEnum.collectStudentPersonalInfo:
            const stuPInfoReqEmptyClone: StudentPersonalInfoViewModel = deepClone(stuPInfoReqEmpty);
            return stuPInfoReqEmptyClone;
        case VerificationStepsEnum.collectSeniorPersonalInfo:
            const seniorPInfoReqEmptyClone: SeniorPersonalInfoViewModel = deepClone(seniorPInfoReqEmpty);
            return seniorPInfoReqEmptyClone;
        case VerificationStepsEnum.collectAgePersonalInfo:
            const agePInfoReqEmptyClone: AgePersonalInfoViewModel = deepClone(agePInfoReqEmpty);
            return agePInfoReqEmptyClone;
        case VerificationStepsEnum.collectTeacherPersonalInfo:
            const teaPInfoReqEmptyClone: TeacherPersonalInfoViewModel = deepClone(teaPInfoReqEmpty);
            return teaPInfoReqEmptyClone;
        case VerificationStepsEnum.collectMemberPersonalInfo:
            const memberInfoReqEmptyClone: MemberPersonalInfoViewModel = deepClone(memberInfoReqEmpty);
            return memberInfoReqEmptyClone;
        case VerificationStepsEnum.collectMilitaryStatus: // Get ActiveMilitaryPersonalInfoViewModel
        case VerificationStepsEnum.collectActiveMilitaryPersonalInfo:
            const activeMilitaryPInfoEmptyClone: ActiveMilitaryPersonalInfoViewModel = deepClone(activeMilitaryPInfoReqEmpty);
            return activeMilitaryPInfoEmptyClone;
        case VerificationStepsEnum.collectInactiveMilitaryPersonalInfo:
            const inactiveMilitaryPInfoEmptyClone: InactiveMilitaryPersonalInfoViewModel = deepClone(inactiveMilitaryPInfoReqEmpty);
            return inactiveMilitaryPInfoEmptyClone;
        case VerificationStepsEnum.collectFirstResponderPersonalInfo:
            const firstResponderPInfoReqEmptyClone: FirstResponderPersonalInfoViewModel = deepClone(firstResponderPInfoReqEmpty);
            return firstResponderPInfoReqEmptyClone;
        case VerificationStepsEnum.collectMedicalProfessionalPersonalInfo:
            const medicalProfessionalPInfoReqEmptyClone: MedicalProfessionalPersonalInfoViewModel = deepClone(medicalProfessionalPInfoReqEmpty);
            return medicalProfessionalPInfoReqEmptyClone;
        case VerificationStepsEnum.collectEmployeePersonalInfo:
            const employmentPInfoReqEmptyClone: EmploymentPersonalInfoViewModel = deepClone(employmentPInfoReqEmpty);
            return employmentPInfoReqEmptyClone;
        case VerificationStepsEnum.docUpload:
            const docUploadEmptyClone: DocUploadViewModel = deepClone(docUploadEmpty);
            return docUploadEmptyClone;
        case VerificationStepsEnum.sso:
            const ssoEmptyClone: SSOViewModel = deepClone(ssoEmpty);
            return ssoEmptyClone;
        case VerificationStepsEnum.smsLoop:
            const smsLoopEmptyClone: SMSLoopViewModel = deepClone(smsLoopEmpty);
            return smsLoopEmptyClone;
        default:
            logger.log('viewModel is not defined for current step');
            return undefined;
    }
};
